import { Injectable } from "@angular/core";
import { Configuration } from "src/app/app.constants";
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { Observable, forkJoin } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class MapsLoaderService {
  private readonly mapConfig = this.configuration.googleMapsConfiguration;

  constructor(private readonly configuration: Configuration) {
    setOptions({
      key: this.mapConfig.key,
      v: this.mapConfig.version.toString(),
    });
  }

  public loadGoogleMapsAPIs(): Observable<any> {
    const fj = forkJoin([
      importLibrary("maps"),
      importLibrary("core"),
      importLibrary("places"),
      importLibrary("geocoding"),
      importLibrary("marker"),
      importLibrary("geometry"),
      importLibrary("drawing"),
      importLibrary("streetView"),
    ]);

    return fj;
  }

  public get mapConfiguration() {
    return this.mapConfig;
  }
}
